import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../lib/theme';
import { cn } from '../../lib/utils';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === 'light' ? 'dark' : 'light';

  return (
    <button
      onClick={toggleTheme}
      data-tour="topbar-theme-toggle"
      className={cn(
        'relative h-10 w-10 rounded-xl transition-all duration-200',
        'flex items-center justify-center',
        'hover:bg-muted',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background'
      )}
      aria-label={`Switch to ${nextTheme} theme`}
    >
      <Sun 
        className={cn(
          'h-5 w-5 transition-all duration-300',
          theme === 'light' 
            ? 'rotate-0 scale-100 text-amber-500' 
            : 'rotate-90 scale-0 absolute'
        )} 
      />
      <Moon 
        className={cn(
          'h-5 w-5 transition-all duration-300',
          theme === 'dark' 
            ? 'rotate-0 scale-100 text-slate-300' 
            : '-rotate-90 scale-0 absolute'
        )} 
      />
    </button>
  );
}
